/**
 * Is this field on screen right now?
 *
 * Conditions come from the round (`{ visible_if: { education_level_code: ["other","OTHER","autre"] } }`),
 * so nothing about which field reveals which is written here.
 *
 * ⚠️ The comparison is case-insensitive because the server ships CASE VARIANTS of the same choice in
 * that list. Matching the first entry exactly would hide the custom-education field for an applicant
 * whose stored value is `OTHER`, silently costing them a required answer.
 */
export function isFieldVisible(
  conditions: Record<string, unknown>,
  values: Record<string, unknown>
): boolean {
  const visibleIf = conditions.visible_if;
  if (visibleIf === undefined || visibleIf === null) return true;
  if (typeof visibleIf !== "object") return true;

  return Object.entries(visibleIf as Record<string, unknown>).every(
    ([key, accepted]) => {
      const current = values[key];
      if (current === undefined || current === null || current === "") {
        return false;
      }
      const list = Array.isArray(accepted) ? accepted : [accepted];
      return list.some(
        (candidate) =>
          String(candidate).toLowerCase() === String(current).toLowerCase()
      );
    }
  );
}
